import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { ExpertAdviceBlock, ProductGrid } from '@as/cotopaxi';
import { useAemConfig } from '@as-react/common-components';
import { Box, Breakpoint, Stack, TextAlpha, useMediaQueryMatchesOnMobile } from '@yonderland/andes-react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { GridTilePlaceholder } from '../../components/lister/grid-tile-placeholder/GridTilePlaceholder';
import { PLACEHOLDER_TILES } from '../../constants/GeneralConstants';
import { I18N_NAMESPACES } from '../../constants/i18nConstants';
import { makeGetContentTiles, makeGetContentCategories, makeGetContentTypes, makeGetLoadingState, } from '../../redux/content/selectors/ContentSelectors';
import { getCategoryAndTypeByTags } from '../../util/content-lister/ContentListerUtil';
import { getImageFromCdn } from '../../util/ImageUtil';
const EXTENDED_TILE_INDEX = 1;
const EmptyResults = ({ alignCenter }) => {
    const { t } = useTranslation(I18N_NAMESPACES.general);
    return (_jsx(Box, { paddingBlock: { base: '4', lg: '16' }, children: _jsxs(Stack, { direction: "col", gap: "4", align: alignCenter ? 'center' : 'start', children: [_jsx(TextAlpha, { variant: "titleXL", children: t('content.overview.no.results.heading') }), _jsx(TextAlpha, { strong: true, children: t('content.overview.no.results.tips') }), _jsx(TextAlpha, { children: t('content.overview.no.results.tip1') }), _jsx(TextAlpha, { children: t('content.overview.no.results.tip2') })] }) }));
};
const ContentListerResultContainer = ({ hideTags }) => {
    var _a;
    const isMobile = useMediaQueryMatchesOnMobile();
    const { mainWebShop, imageCdnPrefix } = useAemConfig();
    const tiles = useSelector(makeGetContentTiles());
    const types = useSelector(makeGetContentTypes());
    const isLoading = useSelector(makeGetLoadingState());
    const categories = useSelector(makeGetContentCategories());
    const contentTiles = (_a = tiles === null || tiles === void 0 ? void 0 : tiles.content) !== null && _a !== void 0 ? _a : [];
    if (contentTiles.length === 0) {
        return (_jsxs(_Fragment, { children: [_jsx(Breakpoint, { until: "lg", children: _jsx(EmptyResults, {}) }), _jsx(Breakpoint, { from: "lg", children: _jsx(EmptyResults, { alignCenter: true }) })] }));
    }
    const getImageSource = (image, responsiveImage, extended = false) => {
        try {
            return getImageFromCdn(JSON.parse(responsiveImage), imageCdnPrefix, extended || isMobile ? '1024' : '480');
        }
        catch (_a) {
            return `${imageCdnPrefix}${image}`;
        }
    };
    return (_jsx(ProductGrid, { extendedIndex: isLoading ? Infinity : EXTENDED_TILE_INDEX, mobileFullwidth: true, children: isLoading
            ? PLACEHOLDER_TILES.map((_, index) => _jsx(GridTilePlaceholder, {}, `grid-item-${index}`))
            : contentTiles.map((contentTile, index) => {
                var _a;
                return (_jsx(ExpertAdviceBlock, { href: contentTile.url, tags: !hideTags ? getCategoryAndTypeByTags(mainWebShop, contentTile.tags, types, categories) : undefined, title: contentTile.title, text: contentTile.description, imageSource: (_a = getImageSource(contentTile.image, contentTile.responsiveImage, index === EXTENDED_TILE_INDEX)) !== null && _a !== void 0 ? _a : '', extended: index === EXTENDED_TILE_INDEX }, `content-tile-${contentTile.title}-${contentTile.sortOrder}`));
            }) }));
};
export default ContentListerResultContainer;
